import { useCart } from "../context/CartContext";

export default function CartItem({ item }){
    const { removeItem, updateItem } = useCart();
    const inc = _=> updateItem(item.id, item.qty + 1);
    const dec = _=> updateItem(item.id, item.qty - 1);
    const rm = _=> removeItem(item.id);

    return <tr>
        <td>
            <img
                src={item.img}
                alt={item.name}
                className="me-2 rounded"
                style={{width: "60px", height: "60px", objectFit: "cover"}} 
            ></img>
            {item.name}
        </td>
        <td>${item.price.toFixed(2)}</td>
        <td className="text-center">
            <button className="btn btn-sm btn-outline-secondary me-1"
                onClick={dec}
            >
                -
            </button>
            {item.qty}
            <button className="btn btn-sm btn-outline-secondary me-1"
                onClick={inc}
            >
                +
            </button>
        </td>
        <td>${(item.price * item.qty).toFixed(2)}</td>
        <td>
            <button
                className="btn btn-sm btn-danger"
                onClick={rm}
            >
                <i className="bi bi-trash"></i>
            </button>
        </td>
    </tr>;
}